/**
 * Centralized GTM dataLayer tracking helpers.
 *
 * Every public function pushes exactly one event object.
 * Import only what you need — tree-shaking removes the rest.
 */

function push(event, data = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...data });
}

// ── PLP ─────────────────────────────────────────────────────────────

export function trackFilterSelected(filterType, filterValue, filterAction) {
  push('plp_filter_selected', {
    filter_type: filterType,
    filter_value: filterValue,
    filter_action: filterAction,
  });
}

export function trackSortChanged(sortValue) {
  push('plp_sort_changed', { sort_value: sortValue });
}

// ── PDP ─────────────────────────────────────────────────────────────

export function trackAddToCart({ productName, productId, productPrice, productVintage, productType }) {
  push('add_to_cart', {
    product_name: productName,
    product_id: productId,
    product_price: productPrice,
    product_vintage: productVintage,
    product_type: productType,
  });
}

export function trackPedigreeClick(productName, horseName) {
  push('pdp_pedigree_click', {
    product_name: productName,
    horse_name: horseName,
  });
}

export function trackArClick(productName) {
  push('pdp_ar_click', { product_name: productName });
}

export function trackBreezeCta(productName) {
  push('pdp_breeze_cta_click', { product_name: productName });
}

export function trackRecirculationClick(productName) {
  push('pdp_recirculation_click', { product_name: productName });
}

// ── Newsletter ──────────────────────────────────────────────────────

export function trackNewsletterSignup(signupLocation) {
  push('newsletter_signup', { signup_location: signupLocation });
}

// ── Cart ────────────────────────────────────────────────────────────

export function trackBeginCheckout(cartValue, itemCount) {
  push('begin_checkout', {
    cart_value: cartValue,
    item_count: itemCount,
  });
}

// ── Trade ───────────────────────────────────────────────────────────

export function trackFileDownload(fileName, fileType, productVintage) {
  push('file_download', {
    file_name: fileName,
    file_type: fileType,
    product_vintage: productVintage,
  });
}

// ── Magazine ────────────────────────────────────────────────────────

export function trackMagazineCategorySelected(category) {
  push('magazine_category_selected', { category });
}

// ── Global navigation ───────────────────────────────────────────────

export function trackFooterLinkClick(value) {
  push('footer_link_click', { value });
}

export function trackNavLinkClick(value) {
  push('nav_link_click', { value });
}
